import { getCachedTareData } from "./TareDataCache";

import { Dimensions, Platform } from "react-native";

const IOS_PHONE_USER_AGENT =
  "Mozilla/5.0 (iPhone; CPU iPhone OS %s like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Mobile/15E148 Indeed App %s";
const IOS_TABLET_USER_AGENT =
  "Mozilla/5.0 (iPad; CPU OS %s like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Mobile/15E148 Indeed App %s";
const ANDROID_PHONE_USER_AGENT =
  "Mozilla/5.0 (Linux; Android %s; SM-S908U Build/TP1A.220624.014; wv) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/0.0.0.0 Mobile Safari/537.36 Indeed App %s";
const ANDROID_TABLET_USER_AGENT =
  "Mozilla/5.0 (Linux; Android %s; SM-P585 Build/QP1A.191005.007.A1; wv) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/0.0.0.0 Mobile Safari/537.36 Indeed App %s";

interface SyntheticUserAgentInput {
  appVersion: string;
  osVersion: string;
  platform: string;
  isTablet: boolean;
}

function formatUserAgent(template: string, osVersion: string, appVersion: string): string {
  return template.replace("%s", osVersion).replace("%s", appVersion);
}

function isTablet(): boolean {
  if (Platform.OS === "ios") {
    return Platform.isPad;
  }

  if (Platform.OS === "android") {
    const { height, width } = Dimensions.get("screen");
    return Math.min(height, width) >= 600;
  }

  return false;
}

function getWebUserAgent(): string {
  return typeof navigator === "undefined" ? "" : navigator.userAgent;
}

export function toSyntheticUserAgent({
  appVersion,
  osVersion,
  platform,
  isTablet,
}: SyntheticUserAgentInput): string {
  if (!appVersion || !osVersion) {
    return "";
  }

  if (platform === "ios") {
    const formattedOsVersion = osVersion.replaceAll(".", "_");
    const template = isTablet ? IOS_TABLET_USER_AGENT : IOS_PHONE_USER_AGENT;
    return formatUserAgent(template, formattedOsVersion, appVersion);
  }

  if (platform === "android") {
    const template = isTablet ? ANDROID_TABLET_USER_AGENT : ANDROID_PHONE_USER_AGENT;
    return formatUserAgent(template, osVersion, appVersion);
  }

  return "";
}

export function getSyntheticUserAgent(): string {
  if (Platform.OS === "web") {
    return getWebUserAgent();
  }

  const tareData = getCachedTareData();

  return toSyntheticUserAgent({
    appVersion: tareData?.appModel?.appVersion ?? "",
    osVersion: tareData?.deviceModel?.osVersion ?? "",
    platform: Platform.OS,
    isTablet: isTablet(),
  });
}
